module.exports = __webpack_public_path__ + "static/media/accessories.c4d4db80.jpg";